<template>
  <div class="container">
    <div class="header">
      <div class="header_title">
        <div class="header_title_text">加入纳微的</div>
        <div class="header_title_image">
          <img src="../../assets/img/6.png" alt="" />
        </div>
        <div class="header_title_text">大理由</div>
      </div>
      <div class="header_desc">
        <span class="header_desc_left"></span>
        <div class="header_desc_text">一起成为优质服务商</div>
        <span class="header_desc_right"></span>
      </div>
      <div class="header_list">
        <div class="header_list_item" v-for="item in headerList" :key="item.id">
          <div class="header_list_item__title">{{ item.title }}</div>
          <div class="header_list_item__num">{{ item.num }}</div>
        </div>
      </div>
      <!-- <img  src="../../assets/img//zhuanlifuwu.jpg" /> -->
    </div>
    <div class="service_project">
      <div class="service_title">
        <div>
          <img src="../../assets/img/service_left.png" alt="" />
        </div>
        <div class="service_title_text">服务项目</div>
        <div>
          <img src="../../assets/img/service_right.png" alt="" />
        </div>
      </div>
      <div class="service_project_list">
        <div class="service_list_item" v-for="item in serviceList" :key="item.id">
          <div class="item_image">
            <img :src="item.url" alt="" />
          </div>
          <div class="item_name">
            {{ item.name }}
          </div>
          <div class="item_desc" style="padding-top: 10px">
            {{ item.desc1 }}
          </div>
          <div class="item_desc">
            {{ item.desc2 }}
          </div>
        </div>
      </div>
    </div>
    <div class="list_main submitRequire" id="submit">
      <el-card class="cardList" shadow="never">
        <div slot="header">
          <h3 class="itemTitle">立即申请成为纳微创新的合作伙伴</h3>
        </div>
        <div style="width: 80%; margin: 0 auto">
          <div class="register_content">
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-width="140px"
              label-position="right"
            >
              <el-form-item label="实验室联系人" prop="laboratoryContact">
                <el-input maxlength="20" v-model="form.laboratoryContact" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="实验室联系电话" prop="contactPhone">
                <el-input v-model="form.contactPhone" placeholder="请输入您的电话"></el-input>
              </el-form-item>
              <el-form-item label="服务范围" prop="scopeOfServices">
                <el-input v-model="form.scopeOfServices" placeholder="测试类/数据分析类/加工类等项目"></el-input>
              </el-form-item>
              <el-form-item label="所在区域" prop="provinceValue">
                <el-cascader
                  @change="handleChange"
                  placeholder="请选择所在区域"
                  style="width: 100%"
                  :options="regionData"
                  v-model="form.provinceValue"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="微信" prop="weChat">
                <el-input v-model="form.weChat" placeholder="请输入微信号"></el-input>
              </el-form-item>
              <el-form-item label="推荐人" prop="referrer">
                <el-input v-model="form.referrer" placeholder="请输入推荐人"></el-input>
              </el-form-item>
              <el-form-item label="推荐人联系方式" prop="referrerPhone">
                <el-input v-model="form.referrerPhone" placeholder="请输入推荐人联系方式"></el-input>
              </el-form-item>
            </el-form>
            <div class="submit">
                <el-button type="primary" style="width: 180px;margin: 0 auto" @click="submitRequire">确认提交</el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { regionData, codeToText } from "element-china-area-data";
import uploadText from "../common/uploadText";
import { saveProducer } from "@/api/request";
export default {
  components: {
    uploadText,
  },
  data() {
    return {
      regionData,
      codeToText,
      form: {},
      rules: {
        laboratoryContact: [{ required: true, trigger: "blur", message: "请输入您的姓名" }],
        contactPhone: [
            { required: true, trigger: "blur", message: "请输入您的电话" }
        ],
        scopeOfServices: [{ required: true, trigger: "blur", message: "请输入服务范围" }],
        province: [{ required: true, trigger: "change", message: "请选择所在区域" }],
      },
      headerList: [
        {
          id: 1,
          title: "年累计订单",
          num: "350000+",
        },
        {
          id: 2,
          title: "年服务人数",
          num: "100000+",
        },
        {
          id: 3,
          title: "每天处理样品",
          num: "1400+",
        },
        {
          id: 4,
          title: "合作伙伴",
          num: "800+",
        },
        {
          id: 5,
          title: "设备使用率提升",
          num: "60%",
        },
        {
          id: 6,
          title: "自我价值提升",
          num: "30%",
        },
      ],
      serviceList: [
        {
          id: 1,
          name: "材料检测",
          desc1: "各类常规测试",
          desc2: "可做云现场和现场",
          url: require("../../assets/img/service_jiancecailiao.png"),
        },
        {
          id: 2,
          name: "高端检测",
          desc1: "国企控股旗下",
          desc2: "第三方检测平台",
          url: require("../../assets/img/service_hightest.png"),
        },
        {
          id: 3,
          name: "模拟计算",
          desc1: "通过理论计算支撑实验结果",
          desc2: "指导实验方向,助您提高论文档次",
          url: require("../../assets/img/service_monijisuan.png"),
        },
        {
          id: 4,
          name: "试剂耗材",
          desc1: "让你的产品",
          desc2: "助力科研试验落地",
          url: require("../../assets/img/service_shijihaocai.png"),
        },
        {
          id: 5,
          name: "科研绘图",
          desc1: "论文封面、插图、摘要图",
          desc2: "助您实现科研成果的精彩绽放",
          url: require("../../assets/img/service_keyanhuitu.png"),
        },
        {
          id: 6,
          name: "专利服务",
          desc1: "20000+项目案例",
          desc2: " AI数据精准匹配",
          url: require("../../assets/img/service_zhuanlifuwu.png"),
        },
      ],
    };
  },
  methods: {
    handleChange(value) {
      this.form.provinceValue = value;
      this.form.provinceCode = value.toString();
      this.form.province = this.getCodeToText(value);
    },
    //把区域码转成汉字
    getCodeToText(value) {
      var name = "";
      value.map(item => (name += codeToText[item] + "/"));
      return name;
    },
    submitRequire() {
      this.$refs.form.validate((valid) => {
        if (valid) {
        //   this.form.clientId = this.$store.getters.userInfo.clientId;
          saveProducer(this.form).then(res => {
            this.$refs["form"].resetFields();
            this.$message.success("提交成功");
            
          }).catch(err => {
            if(err.code == 401){
              this.$message.warning("请先登录");
            }
          })
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container{
  min-width: 1100px;
  background: #FFFFFF;
}
.header {
  width: 100%;
  height: 650px;
  max-width: 1920px;
  background-image: url("../../assets/img/hezuoHeaderBackground.jpg");
  background-size: cover;
  background-position: center;
  margin: 0 auto;
}
.header_title {
  display: flex;
  justify-content: center;
  line-height: 185px;
  padding-top: 120px;
  letter-spacing: 0.5em;
  .header_title_text {
    color: #ffffff;
    font-size: 40px;
    font-weight: 700;
  }
  .header_title_image {
    width: 60px;
    height: 80px;
    padding: 0 10px;
    img {
      width: 60px;
      height: 120px;
    }
  }
}
.header_desc {
  width: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  position: relative;
  .header_desc_text {
    color: #ffffff;
    font-size: 22px;
  }
  .header_desc_left::after {
    display: block;
    content: "";
    width: 100px;
    height: 1.5px;
    background: #ffffff;
    opacity: 0.4;
    position: absolute;
    left: -120px;
    top: 15px;
  }
  .header_desc_right::after {
    display: block;
    content: "";
    width: 100px;
    height: 1.5px;
    background: #ffffff;
    opacity: 0.4;
    position: absolute;
    right: -120px;
    top: 15px;
  }
}
.header_list {
  width: 1000px;
  margin: 50px auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-around;
  .header_list_item {
    width: auto;
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    border-radius: 5px;
    background: #0a517d;
    text-align: center;
    line-height: 30px;
    letter-spacing: 0.2em;
    .header_list_item__title {
      color: #ffffff;
      font-size: 18px;
    }
    .header_list_item__num {
      color: #e0806c;
      font-size: 22px;
    }
  }
}
.service_project {
  width: 100%;
  height: 850px;
  max-width: 1920px;
  margin: 0 auto;
  background-image: url("../../assets/img/service_background.jpg");
  background-size: cover;
  background-position: center;
  .service_title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    img {
      width: 100px;
      height: 20px;
    }
    .service_title_text {
      color: #333;
      font-size: 20px;
      padding: 0 20px;
    }
  }
  .service_project_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    margin: 50px auto;
    .service_list_item {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 40px;
      .item_image {
        width: 200px;
        height: 200px;
        img {
          width: 200px;
          height: 200px;
        }
      }
      .item_name {
        font-weight: 700;
        color: #333;
        font-size: 20px;
        line-height: 30px;
        padding-top: 20px;
      }
      .item_desc {
        color: #333;
        line-height: 22px;
      }
    }
  }
}
.register_Content {
  width: 80%;
  margin: 20px auto;
  text-align: center;
}
.submit{
    width: 100%;
    display: flex;
    justify-content: center;
}
@media only screen and (max-width: 1440px) {
  .header {
    height: 600px;
  }
}

@media only screen and (max-width: 1200px) {
  .header {
    height: 550px;
  }
}
</style>
